<template>
    <!-- <div>
        <transition-group name="fade">
            <div v-for="i in [currentIndex]" :key="i" class="absolute inset-0 w-full h-full">
                <img :src="currentImg" class="w-full h-full object-cover" />
            </div>
        </transition-group>
    </div> -->

    <div class="relative flex items-center w-full min-h-full">
        <slot></slot>

        <!-- :: BUTTON Previous
        {+} ---------------------------------- -->
        <button
            aria-label="previous"
            class="absolute top-1/2 left-0 flex justify-center items-center w-16 h-16 rounded-full text-white md:ml-10 transition-quad z-10 group"
            @click="prev"
        >
            <div
                class="absolute inset-0 w-full h-full bg-transparent lg:group-hover:bg-ocean-500 rounded-full transition-circ lg:group-hover:scale-120"
            ></div>

            <svg class="relative w-6 h-4 fill-current">
                <path d="M23 10H3V7h20z" />
                <path d="M5.121 8.5l6.44 6.44-2.122 2.12L.88 8.5 9.44-.06l2.122 2.12z" />
            </svg>
        </button>

        <!-- :: BUTTON Next
        {+} ---------------------------------- -->
        <button
            aria-label="next"
            class="absolute top-1/2 right-0 flex justify-center items-center w-16 h-16 rounded-full text-white md:mr-10 transition-quad group"
            @click="next"
        >
            <div
                class="absolute inset-0 w-full h-full bg-transparent lg:group-hover:bg-ocean-500 rounded-full transition-circ lg:group-hover:scale-120"
            ></div>

            <svg class="relative w-6 h-4 fill-current">
                <path d="M0 10h20V7H0z" />
                <path d="M17.879 8.5l-6.44 6.44 2.122 2.12 8.56-8.56-8.56-8.56-2.122 2.12z" />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        totalSlides: Number
    },
    data() {
        return {
            currentSlide: 1
        };
    },

    mounted() {
        this.startSlide();
    },

    methods: {
        startSlide() {
            this.timer = setInterval(this.next, 4000);
        },

        next() {
            if (this.currentSlide === this.totalSlides) {
                this.currentSlide = 1;
            } else {
                this.currentSlide++;
            }
        },

        prev() {
            if (this.currentSlide === 1) {
                this.currentSlide = this.totalSlides;
            } else {
                this.currentSlide--;
            }
        }
    }
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    @apply absolute inset-0 w-full opacity-100 visible overflow-hidden transition-all transition-50;
}

.fade-enter,
.fade-leave-to {
    @apply w-full opacity-0 invisible;
}
</style>
